import {
  GET_DOCTOR_DROP,
  GET_DOCTOR_DROP_SUCCESS,
  GET_DOCTOR_DROP_FAILURE,
} from 'store/getDoctorListDropdown/getDoctorListDropdownAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getDoctorDropReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCTOR_DROP:
      return { ...state, loading: true };
    case GET_DOCTOR_DROP_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_DOCTOR_DROP_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getDoctorDropReducer;
